@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/bb-chart.scss';

:host {
  color: var(--main-titles-inputs-600);
  padding-top: calc(var(--spacer) * 1.5);
}

.wrapper {
  flex-direction: column;
  justify-content: space-between;

  .gz-data-item {
    &--value {
      color: var(--main-titles-inputs-600);
    }

    &--delta {
      font-weight: bold;

      &.success {
        color: var(--green-layout-101-primary-green);
      }
    }
  }

  &.is-loading {
    .threats-list,
    .chart-content {
      display: none;
    }
  }

  &.is-empty {
    .threats-list {
      .gz-data-item {
        &--value {
          display: none;
        }
      }
    }
  }
}

.widget-loading {
  bottom: calc(var(--spacer) * 3);
}

.threats-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin: 0;
  }
}

.content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: calc(var(--spacer) * 2);

  .threats-list {
    width: 100%;
  }

  .widget-chart {
    width: 100%;

    .bb-axis-y {
      .tick {
        text {
          fill: var(--main-titles-inputs-600);

          tspan {
            font-family: var(--font-family-secondary-mono);
          }
        }
      }
    }

    .bb-axis-x {
      .tick {
        text {
          fill: var(--main-titles-inputs-600);

          tspan {
            font-family: var(--font-family-secondary);
          }
        }

        &:last-of-type {
          text {
            text-anchor: end !important;
          }
        }

        &:first-of-type {
          text {
            text-anchor: start !important;
          }
        }
      }
    }

    .bb-axis-x,
    .bb-axis-y {
      .tick text tspan {
        font-size: var(--body-size);
      }
    }
  }

  .chart-content {
    width: 100%;
    display: flex;
    align-items: flex-end;
    margin-bottom: var(--spacer);
  }

  &.top-threats-container {
    flex-direction: column-reverse;
  }
}

.chart-tooltip-container {
  min-width: 220px;
}

.bb-tooltip-container {
  transform: translateY(-30%);
}

.bb-chart-hidden-lines {
  .bb-chart-line {
    opacity: 0 !important;
  }

  .bb-axis-x {
    .tick {
      &:last-of-type,
      &:first-of-type {
        text {
          text-anchor: middle !important;
        }
      }
    }
  }

  path {
    fill: none;
    stroke: none;
  }
}

:host([data-display-mode='pdf']) {
  .wrapper {
    .content {
      margin-top: 0 !important;

      .gz-data-item--details {
        font-size: calc(var(--body-size) - 2px);
      }
      .gz-data-item--bullet {
        margin-top: 0;
      }

      .threats-list {
        padding-right: calc(var(--spacer) * 2);
      }
      .gz-data-item--title {
        width: 85%;
      }
    }

    .widget-title {
      height: calc(var(--spacer) * 2);
      margin-bottom: 0;
    }
  }
}
